import emptySplitApi from "../utils/rtk";
import { CitizenshipList, CommonBody } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetCitizenshipResponse = {
  length: number;
  start: number;
  response_object: CitizenshipList[];
  total_records: number;
};

export const citizenshipApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCitizenships: builder.mutation<
      CommonResponseType & { data: GetCitizenshipResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getAllCitizenships,
        method: "POST",
        body,
      }),
    }),

    deleteCitizenship: builder.query<
      CommonResponseType & { data: CitizenshipList },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCitizenship}${id}/`,
        method: "DELETE",
      }),
    }),
    changeCitizenshipStatus: builder.mutation<
      CommonResponseType & { data: CitizenshipList },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.citizenshipStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    citizenshipDetails: builder.query<
      CommonResponseType & { data: CitizenshipList | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.citizenshipById}${id}/`,
        method: "GET",
      }),
    }),
    updateCitizenship: builder.mutation<
      CommonResponseType & { data: CitizenshipList },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCitizenship}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addCitizenship: builder.mutation<
      CommonResponseType & { data: CitizenshipList },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addCitizenship,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetCitizenshipsMutation,
  useLazyCitizenshipDetailsQuery,
  useLazyDeleteCitizenshipQuery,
  useChangeCitizenshipStatusMutation,
  useAddCitizenshipMutation,
  useUpdateCitizenshipMutation,
} = citizenshipApi;
